<template>
  <div id="app" class="container print-page-a4 default_font" style="padding: 0;">
    <div class="row">
      <div class="col-xs-12 text-left" style="margin-top:20px; margin-left:10%; ">
        <div v-if="projectLogo" style="display: inline-block; position: absolute; top: -20px;margin-left:-75px;">
          <img :src="projectLogo" class="resize-project-logo-lg" style="max-width: 150px;" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 text-center" style="margin-top:0px;">
        <div style=" display: inline-block;">
          <div class="default_font_vn" style="font-size: 16px;">Cộng Hòa Xã Hội Chủ Nghĩa Việt Nam</div>
          <div class="default_font_vn" style="font-size: 16px;">Socialist Republic of Vietnam</div>
          <div class="default_font_en" style="font-size: 14px;">Độc Lập - Tự Do - Hạnh Phúc</div>
          <div class="default_font_en" style="font-size: 14px;">Independence - Freedom - Happiness</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 text-center" style="margin-top:20px;">
        <div style=" display: inline-block;">
          <div class="default_font_vn">THÔNG BÁO</div>
          <div class="default_font_en">ANNOUNCEMENT</div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <b><u>Kính gửi:</u> Ông/Bà
          <i>{{ invoicedata.receiptReceiveInfoData ? invoicedata.receiptReceiveInfoData.full_name : invoicedata.resident_fullname }}</i>
          <span style="float: right;"><u>Căn hộ số:</u> {{ invoicedata.resident_address_apartment }}</span>
          </b>
        </div>
        <div class="col-md-12 col-xs-12">
          <b>Địa chỉ:</b> {{ invoicedata.receiptReceiveInfoData ? invoicedata.receiptReceiveInfoData.address : invoicedata.resident_address }}
        </div>
        <div class="col-md-12 col-xs-12 text-center">
          <span class="py-2 my-2">Ban Quản lý vận hành Tòa nhà {{ projectData && projectData.project_name }} - {{ getCompanyName(projectData && projectData.company_name).vi }} xin gửi lời chào trân trọng & lời cảm ơn chân thành đến Quý khách hàng đã tin tưởng chọn mua làm nơi lưu trú du lịch và sử dụng dịch vụ của chúng tôi.</span>
        </div>
        <div class="col-md-12 col-xs-12 text-center">
          <span class="font_italic py-2 my-2">{{ projectData && projectData.project_name }} building’s Operation and Management Board - {{ getCompanyName(projectData && projectData.company_name).en }} would like to send the respectful greeting and thanks to you, our estimable customer for belief in choosing us as your travel residence and using our services.</span>
        </div>

        <div class="col-md-12 col-xs-12">
          <div class="table-responsive" style="margin: 0">
            <table class="table table-condensed customer-info" style="border:0px solid red;margin-bottom: 5px;">
              <tbody>
                <tr>
                  <td style="white-space: nowrap;"><span>Chúng tôi trân trọng thông báo phí dịch vụ tháng</span></td>
                  <td style="white-space: nowrap;"><span>&nbsp;{{ invoicedata.accountingPeriod.month }}/{{ invoicedata.accountingPeriod.year }}</span></td>
                  <td style="white-space: nowrap;"><span>&nbsp;&nbsp;như sau:</span></td>
                  <td style="white-space: nowrap;"><span>&nbsp;Chốt chỉ số từ {{ projectData && projectData.monthly_calculate_period_start }}/{{ invoicedata.accountingPeriod.month }} đến {{ getDueDatePayment() }}</span></td>
                  <td rowspan="2" width="20%">&nbsp;</td>
                </tr>
                <tr style="white-space: nowrap;">
                  <td style="white-space: nowrap;"><span class="font_italic">We would like to inform about the service fees in</span></td>
                  <td style="white-space: nowrap;"><span class="font_italic">&nbsp;{{ invoicedata.accountingPeriod.month }}/{{ invoicedata.accountingPeriod.year }} </span></td>
                  <td style="white-space: nowrap;"><span class="font_italic">&nbsp;&nbsp;as following: </span></td>
                  <td style="white-space: nowrap;"><span class="font_italic">&nbsp;Inventory from {{ projectData && projectData.monthly_calculate_period_start }}/{{ invoicedata.accountingPeriod.month }} until {{ getDueDatePayment() }}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- <div class="col-md-2 col-xs-2"></div> -->
      </div>
      <div class="row" style="margin-bottom: 0px;">
        <div class="col-md-12 col-xs-12">
          <!-- <b>I. Thông tin chi tiết</b>
          <i>&nbsp;/ Information details:</i> -->
          <span style="float: right;" class="font_italic"><b>ĐVT: VNĐ</b></span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <table class="table table_total_fee" style="margin-bottom: 10px">
            <thead class="text-center">
              <!---->
              <tr class="small-item-block">
                <th class="text-center" style="vertical-align: middle; font-size: 12px;" rowspan="2">
                  <b>STT</b>
                  <br />
                  <i class="table_column_en">No.</i>
                </th>
                <th class="text-center" style="vertical-align: middle; font-size: 12px;" rowspan="2">
                  <b>Tên phí DV</b>
                  <br />
                  <i class="table_column_en">Service fees list</i>
                </th>
                <th class="text-center" style="vertical-align: middle; font-size: 12px;" rowspan="2">
                  <b>ĐVT</b>
                  <br />
                  <i class="table_column_en">Unit</i>
                </th>
                <th class="text-center" style="vertical-align: middle; font-size: 12px; background-color:#ffe699" rowspan="2">
                  <b>Đơn giá</b>
                  <br />
                  <i class="table_column_en">Unit price</i>
                </th>
                <th class="text-center" style="vertical-align: middle; font-size: 12px; background-color:#ffe699" rowspan="2">
                  <b>Số lượng</b>
                  <br />
                  <i class="table_column_en">Quantity</i>
                </th>
                <th class="text-center" style="vertical-align: middle; font-size: 12px;" rowspan="2">
                  <b>Thành tiền</b>
                  <br />
                  <i class="table_column_en">Total amount</i>
                </th>
                <th class="text-center" style="vertical-align: middle; font-size: 12px; background-color:#ffe699" colspan="2">
                  <b>Ghi chú /</b>
                  <i class="table_column_en">Notes</i>
                </th>
              </tr>
              <tr class="small-item-block">
                <th class="text-center" style="vertical-align: middle; font-size: 12px; background-color:#ffe699">
                  <b> Open</b>
                  <br />
                  <i class="table_column_en">C.số đầu</i>
                </th>
                <th class="text-center" style="vertical-align: middle; font-size: 12px; background-color:#ffe699">
                  <b> Close</b>
                  <br />
                  <i class="table_column_en">C.số cuối</i>
                </th>
              </tr>
            </thead>
            <tbody class>
              <tr class="small-item-block" v-for="(entry, nindex) in itemServices" :key="entry.id" :uId="entry.id">
                <template v-if="entry.id != ''">
                  <td v-for="(key) in fields" :key="key.id"
                    :style="(key['key'] == 'vatUnitPrice' || key['key'] == 'consumption' || key['key'] == 'last_month_value' || key['key'] == 'this_month_value') ? 'background-color:#ffe699' : ''"
                    >
                    <div v-if="key['key'] == 'total_all'"
                      style="text-align:right;"
                    >
                      <div v-if="entry[key['key']]==0 || entry[key['key']]==null">-</div>
                      <div v-else>{{formatPrice(entry[key["key"]])}} &#8363;</div>
                </div>
                    <div v-else-if="key['key'] == 'vatUnitPrice' || key['key'] == 'quantity'"
                      style="text-align:right;"
                    >
                      <span v-if="entry['price_unit']==0">-</span>
                      <span v-else-if="entry['price_unit']!=null">{{formatPrice(entry['price_unit'])}} &#8363;</span>
                    </div>
                    <div v-else-if="(key['key'] == 'this_month_value' || key['key'] == 'last_month_value')">
                      <div
                        v-if="entry['service_id'] == FixedServiceEnum.ELECTRIC || entry['service_id'] == FixedServiceEnum.WATER"
                        style="text-align:right;"
                      >
                        <div v-if="entry[key['key']]==0 || entry[key['key']]==null">-</div>
                        <div v-else>{{ makeRoundNumber(entry[key["key"]], 1) }}</div>
                      </div>
                    </div>
                    <p v-else-if="key['key'] == 'service_name'" style="text-align:left;">
                      {{formatServiceName(entry[key["key"]], 0)}}
                      <i> / {{ formatServiceName(entry[key["key"]], 1) }}</i>
                    </p>
                    <div
                      v-else-if="key['key'] == 'consumption'"
                      style="text-align:right;"
                    >
                      <span v-if="entry[key['key']]==0">-</span>
                      <span v-else-if="entry[key['key']]!=null">{{ makeRoundNumber(entry[key['key']], 1) }}</span>
                    </div>
                    <p v-else-if="key['key'] == 'STT'" style="text-align:center;">{{nindex + 1}}</p>
                    <p v-else style="text-align:center">{{entry[key["key"]]}}</p>
                  </td>
                </template>
              </tr>

              <tr class="small-item-block">
                <td style="background-color:#66FFFF" colspan="5" class="text-center">
                  <b>Tổng cộng / </b>
                  <i>Total</i>
                </td>
                <td style="background-color:#66FFFF; text-align:right;font-weight:bold;">
                  {{formatPrice(get_total())}} &#8363;
                </td>
                <td style="background-color:#66FFFF;" colspan="2"></td>
              </tr>
            </tbody>

            <tr>
              <td style="background-color:white; padding-left: 10px; font-size:15px" colspan="8">
                Bằng chữ: <b>{{readMoney(get_total(), "vi")}} ./.</b>
                <br>
                <i>In words: {{readMoney(get_total(), "en")}} ./.</i>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-xs-12">
          <i>Giá trên đã bao gồm thuế VAT và phí SVC nếu có.
          <br>
          Price included tax VAT and Service charge</i>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <b>Thời gian đóng phí / Time for payment:</b>
          <span style="display: block;">
            Quý khách vui lòng thanh toán trước ngày {{ invoicedata.dateDueInvoice.date }}/{{invoicedata.dateDueInvoice.month }}/{{ invoicedata.dateDueInvoice.year }}
            <br>
            <i>Please do the payment before on {{ invoicedata.dateDueInvoice.date }}/{{invoicedata.dateDueInvoice.month }}/{{ invoicedata.dateDueInvoice.year }}</i>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <b>Hình thức thanh toán / <i>Payment Method</i>:</b>
          <br>
          Tiền mặt hay chuyển khoản / <i>Cash or Credit card</i>:
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <b>&check; Tiền mặt</b> <i>/ Cash</i>:
          <span style="display: block;">Tại quầy lễ tân của Tòa nhà Ariyana / <i>At the reception  of Ariyana Building</i></span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <b>&check; Thông tin chuyển khoản</b> / <i>Account information</i>:
          <span style="display: block;">Tên chủ tài khoản / <i>Account name:</i> {{invoicedata.account_name}}</span>
          <span style="display: block;">Số tài khoản / <i>Account no.</i>: <b>{{invoicedata.account_no}}</b> - {{ getBankAccountNo() }} - {{ getBankAccountDetails() }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <b>&check; Nội dung thanh toán</b> / <i>Payment purpose</i>:
          <span style="display: block;">Vui lòng ghi rõ như sau: Thanh toán phí dịch vụ {{invoicedata.accountingPeriod.month}}/{{invoicedata.accountingPeriod.year}} cho căn hộ số {{invoicedata.resident_address_apartment}}, Ariyana Smartcondotel</span>
          <span style="display: block;"><i>Please write fully as detail: Service Payment for {{invoicedata.accountingPeriod.month}}/{{invoicedata.accountingPeriod.year}} for Condotel No {{invoicedata.resident_address_apartment}} at Ariyana Smartcondotel when bank transfer</i></span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12" style="margin-top:0.5rem;">
          Lưu ý /<i> Note</i>: Khi đến thanh toán bằng tiền mặt, vui lòng mang theo thông báo này / <i>please show this announcement when payment by cash.</i>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12" style="margin-top:0.5rem;">
          Nếu chậm thanh toán sẽ trả lãi 0,05% mỗi ngày cho tổng số tiền cần thanh toán. Sau 15 ngày kể từ ngày ban hành thông báo thu phí mà Quý khách chưa thanh toán đầy đủ phí dịch vụ thì Ban quản lý Tòa nhà sẽ ngưng cấp điện nước và dịch vụ khác (nếu có) mà không cần thông qua Quý khách.
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <i>If late payment, you have to pay overdue interest per day for total amount to be paid until the actual payment date. After 15 days from issuing this announcement, if you have not yet paid fully, Operation and Management Board will suspend to supply water, electricity and other service (if any) without information in advance with you.</i>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12" style="margin-top:0.5rem;">
          Ban quản lý Tòa nhà rất mong nhận được sự hợp tác của Quý khách / <i>We would like to have your kind cooperation</i>.
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12" style="margin-top:0.5rem;">
          Mọi ý kiến đóng góp, vui lòng liên hệ số hotline ({{ projectData && projectData.customer_care_phone_number }}) Dịch vụ chăm sóc khách hàng của Tòa nhà / <i>Please contact via hotline ({{ projectData && projectData.customer_care_phone_number }}) of customer service of Ariyana Smartcondotel for your feedback</i>
          <!-- {{invoicedata.email_operator}} -->
        </div>
      </div>

      <div class="row" style="border:0px solid red;margin-top:5px;">
        <div>
          <table class="table" style="margin: 0">
            <tbody>
              <tr>
                <td style="width: 50%; border: none;">
                </td>
                <td style="border: none; text-align: center;">
                  <div style="position: relative; width: fit-content; margin: auto;">
                    <div style="white-space: nowrap; font-weight: bold; font-style: italic; position: relative;">
                      {{getDateFooter(this.invoicedata.date_created)}}
                        <img
                          :src="projectData.project_stamp"
                          style="max-height: 150px; position: absolute; top: 10px; left: 35px;" />
                    </div>
                    <span style="white-space: nowrap;">BAN QUẢN LÝ VẬN HÀNH TÒA NHÀ</span>
                    <span style="font-style: italic; white-space: nowrap;">BUILDING’S OPERATION AND MANAGEMENT BOARD</span>
                    <span style="font-style: italic; white-space: nowrap;">Tổng Quản Lý / General Manager</span>
                    <div style="text-align: center; font-weight: bold; margin-top:5rem; white-space: nowrap;">{{ projectData && projectData.managing_director }}</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

// https://vue-multiselect.js.org/
import "vue-multiselect/dist/vue-multiselect.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// import Multiselect from "vue-multiselect";
import moment from "moment";
import utils from "@/lib/utils";
import Enum from "../../../enum/enum"
import FixedServiceEnum from "@/enum/fixedServiceEnum";

export default {
  props: ["item", "projectData", "printInvoiceType"],
  name: "component_invoice_template_republic",
  data() {
    return {
      electricTitleVN: "THÔNG BÁO THU PHÍ ĐIỆN, NƯỚC THÁNG",
      electricTitleEN: "ELECTRIC & WATER BILL",
      managementTitleVN: "THÔNG BÁO THU PHÍ QUẢN LÝ",
      managementTitleEN: "MANAGEMENT FEE ANNOUNCEMENT",
      projectLogo: null,
      // fields for show list service Usage
      fields: [
        { key: "STT" },
        { key: "service_name" },
        { key: "service_unit" },
        { key: "vatUnitPrice" }, // { "price_unit * vat" },
        { key: "consumption" }, // { key: "quantity" },
        { key: "total_all" }, // { key: "total_fees" },
        { key: "last_month_value" },
        { key: "this_month_value" }
      ],
      // data for show list service Usage
      itemServices: [],
      sum_total: 0,
      // MultiSelect Service availabe
      // optionServiceSelected: null, //[{ name: 'Javascript', code: 'js' }]
      // optionServices: [], //[{"name":"Vue.js","code":"vu"},{"name":"Javascript","code":"js"},{"name":"Open Source","code":"os"}],

      // disabledOptionServices: true,
      // service_usage_list: [],

      form: {
        date_issued: new Date(),
        date_paid: new Date(),
        service: null,
        device: null,
        user: this.$route.params.id
      },
      options: {
        format: "DD/MM/YYYY"
      },
      actionType: "",

      // Customer List
      customerList: [
        {
          value: null,
          text: "Select One"
        }
      ], //[{"value":1,"text":"Loi"},{"value":2,"text":"Loc"},{"value":3,"text":"Tuan"},{"value":4,"text":"Hung"},{"value":5,"text":"Hau"}]
      customerSelected: null,
      disabledCustomerList: true,

      // Status Invoice List
      statusList: [
        {
          value: null,
          text: "Select One"
        }
      ], //[{"value":1,"text":"Issue"},{"value":2,"text":"Paid"},{"value":3,"text":"Cancelled"}]
      statusSelected: null,
      disabledStatusList: false,

      search: {
        from_date: null,
        to_date: null,
        apartment_code: ""
      },

      search_result_detail: "",
      search_result: "",

      show: false,
      invoicedata: {
        id: 0,
        invoice_number: "",
        invoice_user: null,
        invoice_status: 1, // set default is Issued
        invoice_status_name: "",
        date_issued: "",
        date_paid: "",
        other_details: "",

        mainowner_fullname: "",
        mainowner_address: "",
        mainowner_email: "",
        mainowner_country: "",
        mainowner_phone: "",
        mainowner_tax: "",

        resident_fullname: "",
        resident_address_apartment: "",
        resident_address: "",
        resident_email: "",
        resident_country: "",
        resident_phone: "",
        resident_tax: "",

        account_no: "",
        account_name: "",
        transferring_contentVN: "",
        transferring_contentEN: "",
        contact_us: "",
        date_created: new Date(),
        periodStringTitleVN: "",
        periodStringTitleEN: "",
        month: "",
        liability_cash_surplus: 0,

        total_liability_cash: 0,
        old_debt: 0,
        accountingPeriod: {
          month: 0,
          year: 0
        },
        dateDueInvoice: {
          date: '',
          month: '',
          year: '',
          monthEn: ''
        },
        invoice_description: null,
        email_operator: null,
        receiptReceiveInfoData: null,
        countSendEmail: 0
      },

      isModalVisible: false,
      FixedServiceEnum: FixedServiceEnum,
      montlyInvoice: null
    };
  },
  watch: {
    projectData: function() {
      this.projectLogo = !utils.isNull(this.projectData) ? this.projectData.project_logo : null
    }
  },
  computed: {
    functionExample: function() {
      return "";
    },

    ...mapGetters("accountingHomeLiabilityModule", {
      search_accounting_home_liability_list:
        "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST",
      search_accounting_home_liability_list_detail:
        "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL"
    }),
    ...mapGetters([
      "INVOICE_DETAIL_DATA",
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    isEmptyString: function(value) {
      return utils.isEmptyString(value)
    },
    readMoney: function(number, locale) {
      return utils.readMoney(number, locale);
    },
    closeModal() {
      this.isModalVisible = false;
    },

    ...mapActions("accountingHomeLiabilityModule", [
      "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL",
      "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST"
    ]),
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST"
    ]),

    CancelInvoiceList: function() {
      this.$router.push({
        name: "InvoiceList"
      });
    },
    onConfirm: function() {
      this.isModalVisible = false;
    },

    printInvoice: function() {
      document.getElementById("cmdCancel").style.display = "none";
      document.getElementById("cmdPrintPdf").style.display = "none";
      window.print();
      document.getElementById("cmdCancel").style.display = "";
      document.getElementById("cmdPrintPdf").style.display = "";
    },
    getDateFooter(date) {
      // Day
      let day = utils.formatSqlDate(date, null, "DD");
      // Month
      let month = utils.formatSqlDate(date, null, "MM");
      // Year
      let year = utils.formatSqlDate(date, null, "YYYY");
      return "Nha Trang, ngày " + day + " tháng " + month + " năm " + year;
    },
    convertDateVN(date) {
      // Day
      let day = utils.formatSqlDate(date, null, "DD");
      // Month
      let month = utils.formatSqlDate(date, null, "MM");
      // Year
      let year = utils.formatSqlDate(date, null, "YYYY");
      return "ngày " + day + " tháng " + month + " năm " + year;
    },
    convertDateMonth(date) {
      // Month
      let month = utils.formatSqlDate(date, null, "MM");
      // Year
      let year = utils.formatSqlDate(date, null, "YYYY");
      return " tháng " + month + " năm " + year;
    },
    convertDateEN(date) {
      return utils.formatSqlDate(date, null, "DD MMM YYYY");
    },
    formatPrice(price, isFormat = false) {
      if (price != undefined) {
        price = utils.makeRoundNumber(price);
        let rs = price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return rs == 0 && isFormat ? "-" : rs;
      }
      return ''
    },
    makeRoundNumber(value, decimalPlaces) {
      return Number(value).toFixed(decimalPlaces);
      // return utils.makeRoundNumber(value, decimalPlaces)
    },
    formatServiceName(service_name, index) {
      let item = service_name.split("/");
      return `${item[index]}`;
    },
    formatDate(date) {
      return utils.formatSqlDate(date, null, "DD/MM/YYYY");
    },
    get_total() {
      return this.sum_total + this.invoicedata.old_debt;
      // return this.invoicedata.total_liability_cash + this.sum_total;
    },

    // Excute search
    // Author: loitt
    // Input:
    // const data = {
    //   from_date: from_date,
    //   to_date: to_date,
    //   apartment_code: this.search.apartment_code
    // };
    // Output: list result
    onSearch() {
      let from_date = moment(this.search.from_date).subtract(1, "days").format("DD/MM/YYYY hh:mm:ss"); // months
      let to_date = moment(this.search.to_date).subtract(1, "days").format("DD/MM/YYYY hh:mm:ss");

      if (utils.isNull(this.search.apartment_code)) {
        this.ON_SHOW_TOAST({
          message: this.$t(
            "report_accounting_home_liability_detail.error.apartment_code"
          ),
          styleType: "danger"
        });
        return;
      }
      const data = {
        from_date: from_date,
        to_date: to_date,
        apartment_code: this.search.apartment_code
      };
      // this.get_search_accounting_home_liability_list_detail(data)
      this.get_search_accounting_home_liability_list(data);
    },
    get_search_accounting_home_liability_list_detail(data) {
      this.isLoading = true;
      this.SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL(data)
        .then(
          function(res) {
            this.search_result_detail = res.data;
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            // check input error
            this.ON_SHOW_TOAST({
              message: "ERROR",
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    get_search_accounting_home_liability_list(data) {
      this.isLoading = true;
      this.SEARCH_ACCOUNTING_HOME_LIABILITY_LIST(data)
        .then(
          function(res) {
            if (res.data.length > 0) {
              this.search_result = res.data;
              // liability_cash_surplus = Tiền Ứng = Cuối Kỳ Có
              this.invoicedata.liability_cash_surplus = this.search_result[0].closing_trade_payable_yes_max;
              // total_liability_cash = Dư Nơ = Cuối Kỳ Nợ
              this.invoicedata.total_liability_cash = this.search_result[0].closing_trade_payable_max;
            }
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            // check input error
            this.ON_SHOW_TOAST({
              message: "ERROR",
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    getCompanyName: function(data) {
      let companyNameSplit = !utils.isEmptyString(data) ? data.split("|") : []
      let companyNameVN = utils.getCleanStringValue(companyNameSplit[0], "")
      let companyNameEN = utils.getCleanStringValue(companyNameSplit[1], "")
      return {
        vi: companyNameVN,
        en: companyNameEN
      }
    },
    getBankAccountNo: function() {
      if (this.projectData && this.projectData.projectbankaccounts[0]) {
        let bankCode = this.projectData.projectbankaccounts[0].bank_code
        return bankCode !== null ? bankCode.bank_code : ''
      }
      return ''
    },
    getBankAccountDetails: function() {
      if (this.projectData && this.projectData.projectbankaccounts[0]) {
        return this.projectData.projectbankaccounts[0].bank_other_details
      }
      return ''
    },
    getDueDatePayment: function() {
      if (this.invoicedata.accountingPeriod.month < 12) {
        return `${this.projectData && this.projectData.monthly_calculate_period_end}/${this.invoicedata.accountingPeriod.month}/${this.invoicedata.accountingPeriod.year}`
      } else {
        return `${this.projectData && this.projectData.monthly_calculate_period_end}/1/${this.invoicedata.accountingPeriod.year + 1}`
      }
    },
    getDateDueInvoiceData: function(dateDueInvoice) {
      if (!utils.isEmptyString(dateDueInvoice)) {
        let result = moment(dateDueInvoice)
        if (!utils.isEmptyString(result)) {
          return {
            date: result.format("DD"),
            month: result.format("MM"),
            year: result.format("YYYY"),
            monthEn: result.format("MMMM")
          }
        }
      }
      return {
        date: '',
        month: '',
        year: '',
        monthEn: ''
      }
    }
  },
  async mounted() {
    let invoiceType = this.$route.query.invoiceType
    if (invoiceType !== undefined) {
      this.montlyInvoice = (invoiceType == Enum.invoiceTypeEnum.MONTHLY) ? true : false
    }

    this.search.from_date = this.item.date_created;
    this.search.to_date = this.item.date_created;
    this.search.apartment_code = this.item.apartment.apartment_code;

    // await this.onSearch();
    this.invoicedata.date_created = this.item.date_created;
    this.invoicedata.invoice_number = this.item.invoice_number;
    // this.invoicedata.invoice_user = this.item.user.id;

    if (this.item.invoice_to_company_flag) {
      // Company
      // this.invoicedata.resident_fullname =
      //     this.INVOICE_DETAIL_DATA.user.company_name + " - (C) ";
      this.invoicedata.resident_fullname = this.item.owner_apartment.company_name;
      this.invoicedata.resident_tax = this.item.owner_apartment.company_tax_code;
      this.invoicedata.resident_address_apartment = this.item.owner_apartment.company_address;
      this.invoicedata.resident_address = this.item.owner_apartment.company_address;
      this.invoicedata.resident_phone = this.item.owner_apartment.phone;
    } else {
      // Customer
      // this.invoicedata.resident_fullname =
      //     this.INVOICE_DETAIL_DATA.user.name + " - (P) ";
      this.invoicedata.resident_fullname = this.item.owner_apartment.fullname;
      this.invoicedata.resident_tax = this.item.owner_apartment.personal_tax_code;
      this.invoicedata.resident_address_apartment = this.item.apartment.apartment_code;
      this.invoicedata.resident_address = this.item.owner_apartment ? ((utils.isNull(this.item.owner_apartment.address)) ? this.item.apartment.apartment_code : this.item.owner_apartment.address) : '';
      this.invoicedata.resident_phone = this.item.owner_apartment.phone;
    }
    this.itemServices = this.item.service_usage_list;
    let initialValue = 0;
    this.sum_total = this.itemServices.reduce(function(total, currentValue) {
      return total + utils.makeRoundNumber(currentValue.total_all);
    }, initialValue);
    this.invoicedata.old_debt = this.itemServices.reduce(function(total, currentValue) {
      return total + utils.makeRoundNumber(currentValue.old_debt);
    }, initialValue);

    this.invoicedata.resident_country = this.item.owner_apartment.country_name;
    this.invoicedata.resident_email = this.item.owner_apartment.email;
    this.invoicedata.resident_phone = this.item.owner_apartment.phone;

    this.invoicedata.invoice_status = this.item.invoice_status.id;
    this.invoicedata.invoice_status_name = this.item.invoice_status.status_description;

    this.invoicedata.other_details = this.item.other_details;

    let accounting_period = utils.getCleanStringValue(this.item.accounting_period, '')
    this.invoicedata.accountingPeriod.month = utils.makeRoundNumber(accounting_period.slice(4,6))
    this.invoicedata.accountingPeriod.year = utils.makeRoundNumber(accounting_period.slice(0,4))

    if (this.item.date_issued == null) {
      this.form.date_issued = new Date();
    } else {
      this.form.date_issued = this.item.date_issued;
    }
    this.invoicedata.date_issued = utils.formatSqlDate(this.form.date_issued, null, "DD-MMM-YYYY");
    if (this.item.due_date == null) {
      this.form.due_date = "";
    } else {
      this.form.due_date = this.item.due_date;
    }

    this.invoicedata.due_date = utils.formatSqlDate(this.form.due_date, null, "DD-MMM-YYYY", "");
    if (this.item.date_paid == null) {
      this.form.date_paid = new Date();
    } else {
      this.form.date_paid = this.item.date_paid;
    }
    this.invoicedata.date_paid = utils.formatSqlDate(this.form.date_paid, null, "DD-MMM-YYYY");

    this.invoicedata.dateDueInvoice = this.getDateDueInvoiceData(this.item.date_payment_invoice)
    this.invoicedata.invoice_description = this.item.invoice_description
    this.invoicedata.email_operator = this.item.email_operator

    // liability_cash_surplus = Tiền Ứng = Cuối Kỳ Có
    this.invoicedata.liability_cash_surplus = this.item.liability_cash_surplus;
    // total_liability_cash = Dư Nơ = Cuối Kỳ Nợ
    this.invoicedata.total_liability_cash = this.item.total_liability_cash;

    if(this.item.banktransfer != null ){
        this.invoicedata.account_no =  this.item.banktransfer.account_no ;
        this.invoicedata.account_name = this.item.banktransfer.account_name;
        this.invoicedata.transferring_contentVN = this.item.banktransfer.transferring_content;
        this.invoicedata.transferring_contentEN = this.item.banktransfer.transferring_content;
        this.invoicedata.contact_us = this.item.banktransfer.contact_us;
    }

    this.invoicedata.receiptReceiveInfoData = this.item.receipt_receive_info_data
    this.invoicedata.countSendEmail = this.item.count_send_email

    this.projectLogo = !utils.isNull(this.projectData) ? this.projectData.project_logo : null
  },
  components: {
  }
};
</script>

<style scoped>
.print-page-a4 {
  width: 210mm !important;
  /* height: 297mm !important; */
  margin: 10mm auto !important;
  border: 1px #D3D3D3 solid;
  border-radius: 5px !important;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  /* font-family: 'Roboto', sans-serif !important; */
  /* line-height: 1.7 !important; */
}
.btn-label {
  position: relative;
  left: -12px;
  display: inline-block;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px 0 0 3px;
}

.btn-labeled {
  padding-top: 0;
  padding-bottom: 0;
}

.btn {
  margin-bottom: 10px;
}

.table_total_fee {
  border: 1px solid #000000 !important;
}

.table_total_fee thead tr,
.table_total_fee thead tr th,
.table_total_fee td,
.table_total_fee th {
  border: 1px solid #000000 !important;
}

.container {
  font-family: Times New Roman, Times, serif !important;
  width: 210mm !important;
  margin: 5mm auto 0mm auto !important;
  padding-left: 2.5mm !important;
  padding-right: 7.5mm !important;
}

body {
  font-size: 12px !important;
}
.resize-project-logo-lg {
  height: auto;
  width: auto;
  max-width: 150px;
  max-height: 120px;
}
@media print {
  html, body {
    width: 210mm !important;
    height: auto;
  }
  body.print {
    width: 210mm !important;
    height: auto;
  }
  .print-page-a4 {
    margin: 0 !important;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    /* line-height: 1.7 !important; */
  }
}
/* remove title when print */
@page {
  size: A4 portrait;
  margin: 10mm 0mm 15mm 0mm;
}

.table_column_en {
  font-style: italic;
  font-weight: 100;
}
.font_italic {
  font-style: italic;
}
tr.small-item-block td {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
  vertical-align : middle;
}
tr.small-item-block th {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
  vertical-align : middle;
}
tr.small-item-block td p {
  margin: 0
}
/* .default_font_vn {
    font-size: 15px;
    font-style: normal;
    font-weight: bold;
    text-transform: uppercase;
} */
.customer-info tbody tr td{
  border: none;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/Invoice/component_invoice_template_ariyana.vue